// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const listRunGroupsApiAiRunsGroupsGetParamsSortDefault = `cost_usd`;
export const listRunGroupsApiAiRunsGroupsGetParamsSortMax = 40;

export const listRunGroupsApiAiRunsGroupsGetParamsOrderDefault = `desc`;
export const listRunGroupsApiAiRunsGroupsGetParamsPageDefault = 1;

export const listRunGroupsApiAiRunsGroupsGetParamsPageSizeDefault = 50;
export const listRunGroupsApiAiRunsGroupsGetParamsPageSizeMax = 200;

export const listRunGroupsApiAiRunsGroupsGetParamsProcessItemMax = 120;

export const listRunGroupsApiAiRunsGroupsGetParamsProcessDefault = [];
export const listRunGroupsApiAiRunsGroupsGetParamsProcessMax = 50;

export const listRunGroupsApiAiRunsGroupsGetParamsModelItemMax = 120;

export const listRunGroupsApiAiRunsGroupsGetParamsModelDefault = [];
export const listRunGroupsApiAiRunsGroupsGetParamsModelMax = 50;

export const listRunGroupsApiAiRunsGroupsGetParamsUserItemMax = 120;

export const listRunGroupsApiAiRunsGroupsGetParamsUserDefault = [];
export const listRunGroupsApiAiRunsGroupsGetParamsUserMax = 50;

export const listRunGroupsApiAiRunsGroupsGetParamsStatusItemMax = 40;

export const listRunGroupsApiAiRunsGroupsGetParamsStatusDefault = [];
export const listRunGroupsApiAiRunsGroupsGetParamsStatusMax = 50;

export const listRunGroupsApiAiRunsGroupsGetParamsCostMinOneMin = 0;
export const listRunGroupsApiAiRunsGroupsGetParamsCostMinOneMax = 1000000;

export const listRunGroupsApiAiRunsGroupsGetParamsCostMaxOneMin = 0;
export const listRunGroupsApiAiRunsGroupsGetParamsCostMaxOneMax = 1000000;

export const listRunGroupsApiAiRunsGroupsGetParamsLatencyMinMsOneMin = 0;

export const listRunGroupsApiAiRunsGroupsGetParamsLatencyMaxMsOneMin = 0;

export const listRunGroupsApiAiRunsGroupsGetParamsMonthOneMax = 7;

export const listRunGroupsApiAiRunsGroupsGetParamsYearOneMax = 4;

export const ListRunGroupsApiAiRunsGroupsGetParams = zod.object({
  "by": zod.enum(['process', 'model', 'user', 'day', 'month']),
  "sort": zod.string().max(listRunGroupsApiAiRunsGroupsGetParamsSortMax).default(listRunGroupsApiAiRunsGroupsGetParamsSortDefault),
  "order": zod.enum(['asc', 'desc']).default(listRunGroupsApiAiRunsGroupsGetParamsOrderDefault),
  "page": zod.int().min(1).default(listRunGroupsApiAiRunsGroupsGetParamsPageDefault),
  "page_size": zod.int().min(1).max(listRunGroupsApiAiRunsGroupsGetParamsPageSizeMax).default(listRunGroupsApiAiRunsGroupsGetParamsPageSizeDefault),
  "process": zod.array(zod.string().max(listRunGroupsApiAiRunsGroupsGetParamsProcessItemMax)).max(listRunGroupsApiAiRunsGroupsGetParamsProcessMax).default(listRunGroupsApiAiRunsGroupsGetParamsProcessDefault),
  "model": zod.array(zod.string().max(listRunGroupsApiAiRunsGroupsGetParamsModelItemMax)).max(listRunGroupsApiAiRunsGroupsGetParamsModelMax).default(listRunGroupsApiAiRunsGroupsGetParamsModelDefault),
  "user": zod.array(zod.string().max(listRunGroupsApiAiRunsGroupsGetParamsUserItemMax)).max(listRunGroupsApiAiRunsGroupsGetParamsUserMax).default(listRunGroupsApiAiRunsGroupsGetParamsUserDefault),
  "status": zod.array(zod.string().max(listRunGroupsApiAiRunsGroupsGetParamsStatusItemMax)).max(listRunGroupsApiAiRunsGroupsGetParamsStatusMax).default(listRunGroupsApiAiRunsGroupsGetParamsStatusDefault),
  "created_from": zod.union([zod.iso.datetime({"offset":true}),zod.null()]).optional(),
  "created_to": zod.union([zod.iso.datetime({"offset":true}),zod.null()]).optional(),
  "cost_min": zod.union([zod.number().min(listRunGroupsApiAiRunsGroupsGetParamsCostMinOneMin).max(listRunGroupsApiAiRunsGroupsGetParamsCostMinOneMax),zod.string(),zod.null()]).optional(),
  "cost_max": zod.union([zod.number().min(listRunGroupsApiAiRunsGroupsGetParamsCostMaxOneMin).max(listRunGroupsApiAiRunsGroupsGetParamsCostMaxOneMax),zod.string(),zod.null()]).optional(),
  "latency_min_ms": zod.union([zod.int().min(listRunGroupsApiAiRunsGroupsGetParamsLatencyMinMsOneMin),zod.null()]).optional(),
  "latency_max_ms": zod.union([zod.int().min(listRunGroupsApiAiRunsGroupsGetParamsLatencyMaxMsOneMin),zod.null()]).optional(),
  "month": zod.union([zod.string().max(listRunGroupsApiAiRunsGroupsGetParamsMonthOneMax),zod.null()]).optional(),
  "year": zod.union([zod.string().max(listRunGroupsApiAiRunsGroupsGetParamsYearOneMax),zod.null()]).optional()
})

export type ListRunGroupsApiAiRunsGroupsGetParams = zod.input<typeof ListRunGroupsApiAiRunsGroupsGetParams>;
export type ListRunGroupsApiAiRunsGroupsGetParamsOutput = zod.output<typeof ListRunGroupsApiAiRunsGroupsGetParams>;
